import { Component, Injector, Input } from "@angular/core";
import { ChoiceListItemLike, ChoiceListItemQuery } from "ng/src/app/choice-lists/shared/choice-list.model";
import { Observable } from "rxjs";
import { ChoiceListService } from "ng/src/app/choice-lists/shared/choice-list.service";
import { PagedArray } from "app/shared/model/app.model";
import { QuerySelectorComponent } from "ng/src/app/shared/item-selectors/query-selector/query-selector.component";
import { QuerySelectorType } from "ng/src/app/shared/item-selectors/query-selector/query-selector.model";

@Component({
	selector: 'choicelist-item-selector:[listId]',
	templateUrl: '../shared/item-selectors/query-selector/query-selector.component.html',
	styleUrls: ['../shared/item-selectors/query-selector/query-selector.component.scss'],
	providers: [QuerySelectorComponent.ProviderAccessor(ChoiceListItemSelectorComponent)]
})
export class ChoiceListItemSelectorComponent extends QuerySelectorComponent<ChoiceListItemLike, ChoiceListItemQuery> {
	@Input() listId!: number;
	
	displayField: keyof ChoiceListItemLike = "value";
	idField: keyof ChoiceListItemLike = "value";
	type = QuerySelectorType.Single
	
	constructor(
		private choiceListService: ChoiceListService,
		injector: Injector,
	) {
		super(injector);
	}
	
	protected constructQuery(query: string): ChoiceListItemQuery {
		return {
			listId: this.listId,
			sort: 'sortOrder,asc',
			matches: query
		} as ChoiceListItemQuery
	}
	
	protected fetch(query: ChoiceListItemQuery): Observable<PagedArray<ChoiceListItemLike>> {
		return this.choiceListService.fetchItems(query);
	}
}